import Component from "./DefaultLeaderboard";

export default Component;
